import { useEffect } from 'react';
import { APP_NAME, DEFAULT_PAGE_DESCRIPTION } from '../config/appConfig';

export function useDocumentMetadata(
  pageTitle: string,
  description: string = DEFAULT_PAGE_DESCRIPTION
) {
  useEffect(() => {
    document.title = `${pageTitle} | ${APP_NAME}`;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', description);
    }
  }, [description, pageTitle]);
}
